/* istanbul ignore file */
/* eslint-disable */
// @ts-nocheck

/**
 * Check if a value is an object
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
// eslint-disable-next-line wix-custom-rules/wixstores-file-names,import/no-default-export
export default function isObject(value) {
  return value !== null && typeof value === 'object';
}
